import React, { useEffect, useRef, useState } from "react";
import { AppConfig } from "../../AppConfig";

declare global {
  interface Window {
    turnstile?: any;
  }
}

type CloudflareTurnstileProps = {
  size?: "normal" | "compact" | "invisible";
  onVerify: (token: string) => void;
  resetTrigger?: number;
};

const CloudflareTurnstile: React.FC<CloudflareTurnstileProps> = ({
  size = "normal",
  onVerify,
  resetTrigger = 0,
}) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const [widgetId, setWidgetId] = useState<string | null>(null);

  useEffect(() => {
    const scriptId = "cloudflare-turnstile-script";
    if (!document.getElementById(scriptId)) {
      const script = document.createElement("script");
      script.id = scriptId;
      script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?onload=onloadTurnstileCallback";
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    }

    const initializeTurnstile = () => {
      if (window.turnstile && ref.current && !widgetId) {
        const theme = "light";
        const id = window.turnstile.render(ref.current, {
          sitekey: AppConfig.CLOUDFLARE_SITE_KEY,
          size,
          theme,
          callback: (token: string) => {
            onVerify(token);
          },
          'expired-callback': () => {
            if (ref.current && window.turnstile) {
              window.turnstile.reset(id);
            }
          },
        });
        setWidgetId(id);
      }
    };

    const interval = setInterval(() => {
      if (window.turnstile) {
        clearInterval(interval);
        initializeTurnstile();
      }
    }, 100);

    return () => clearInterval(interval);
  }, [size, onVerify, widgetId]);

  useEffect(() => {
    if (widgetId && window.turnstile && resetTrigger > 0) {
      window.turnstile.reset(widgetId);
    }
  }, [resetTrigger, widgetId]);

  return <div ref={ref}></div>;
};

export default CloudflareTurnstile;
